
import React from 'react';
import { Bell } from 'lucide-react';
import { motion } from 'framer-motion';

export const NotificationEmptyState = () => {
  return (
    <motion.div 
      className="py-12 px-4 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ 
          duration: 0.5,
          type: "spring",
          stiffness: 100 
        }}
      >
        <Bell className="h-12 w-12 mx-auto text-muted-foreground mb-3 opacity-40" />
      </motion.div>
      <p className="text-muted-foreground text-sm">You're all caught up</p>
      <p className="text-muted-foreground/60 text-xs mt-1">Notifications will appear here when you receive them</p>
    </motion.div>
  );
};
